<template>
  <div>
    <app-toolbar :crumbs="crumbs">
      <v-spacer></v-spacer>
    </app-toolbar>

    <version-chips v-model="model"></version-chips>

    <v-alert v-if="model.status == 'published'" type="warning">
      This version is already published
    </v-alert>

    <validation-result
      child-label="Topics"
      :validation="validation"
      @click="onItemClicked"
    />

    <v-card flat tile class="mt-2">
      <v-card-actions>
        <v-btn
          v-if="model.id"
          icon
          color="default"
          aria-label="refresh"
          @click="onRefresh"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="model.id"
          plain
          color="default"
          :to="{
            name: 'component-detail',
            params: {
              moduleId: moduleId,
              componentId: model.id
            }
          }"
        >
          Cancel
        </v-btn>
        <v-btn
          tile
          large
          color="primary"
          @click.once="onPublish"
          :disabled="!canPublish"
        >
          Publish
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { components as componentsApiBuilder } from '@/services/api'
import contentPageMixin from '@/components/mixins/content-page'
import validationResult from '@/components/publishing/validation-result'

export default {
  mixins: [contentPageMixin],
  components: {
    validationResult
  },
  data() {
    return {
      model: {},
      validation: {},
      isValididated: false,
      componentsApi: null
    }
  },
  computed: {
    canPublish() {
      return this.model.status == 'draft' && this.validation.succeeded
    }
  },
  async mounted() {
    this.componentsApi = componentsApiBuilder.build(this.module.id)
    this.model = this.component
    this.validate()
  },
  watch: {
    component(val) {
      this.model = _.cloneDeep(val)
    }
  },
  methods: {
    ...mapActions('context', ['clearModule']),
    async validate() {
      this.isValididated = false
      this.validation = await this.componentsApi.validate(this.component.id)
      this.isValididated = true
    },
    async onPublish() {
      this.loading = true

      const response = await this.componentsApi.publish(this.component.id)

      this.addMessage({
        message: `Component '${this.model.name}' version ${response.version} has been published.`
      })

      const routeParams = {
        moduleId: this.moduleId
      }

      this.clearModule()

      this.$router.push({
        name: 'module-detail',
        params: routeParams
      })
      this.loading = false
    },
    async onRefresh() {
      this.loading = true
      await this.validate()
      this.loading = false
    },
    onItemClicked(item) {
      const routeData = this.$router.resolve({
        name: 'topic-detail',
        params: {
          moduleId: this.moduleId,
          componentId: this.componentId,
          topicId: item.id
        }
      })

      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
.card {
  margin: 0px 15px;
}
.procedure {
  margin-left: 15px;
}
</style>
